import { render, staticRenderFns } from "./chooseCopy.vue?vue&type=template&id=7b5b3ee6&scoped=true"
import script from "./chooseCopy.vue?vue&type=script&lang=js"
export * from "./chooseCopy.vue?vue&type=script&lang=js"
import style0 from "./chooseCopy.vue?vue&type=style&index=0&id=7b5b3ee6&prod&lang=scss"
import style1 from "./chooseCopy.vue?vue&type=style&index=1&id=7b5b3ee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5b3ee6",
  null
  
)

export default component.exports